import axiosInstance from "./AxiosInstance"

export function getUserListApi(param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`/api/users?${fparam}`)
}

export function createUserApi(data){
    return axiosInstance.post('/api/users',data)
}

export function editUserApi(id, data) {
    return axiosInstance.patch(`/api/users/${id}`, data);
}

export function deleteUserApi(id) {
    return axiosInstance.delete(`/api/users/${id}`);
}

export function getUserDetailsApi() {
    return axiosInstance.get('/api/users-me');
}
export function getUserServicecenterDeatailsApi() {
    return axiosInstance.get('api/user/service-center/');
}